console.log("Accessibility scripts loaded");
document.addEventListener("DOMContentLoaded", () => {
  // NOTE (2026-07): This block was written for the Sep 2023 mega menu. The menu has
  // since been redesigned — ".mega-menu__image-wrapper" no longer matches the current
  // markup, so these labels are currently a no-op. Previously this threw
  // (mega[0] was undefined), which also blocked the footer-link line below and any
  // other DOMContentLoaded work. Now guarded so a missing element can never throw.
  // If these aria-labels are still needed, set them in the mega menu Liquid instead.
  const megaLabels = [
    "Purifier Bottle Collection",
    "Cartridge Replacement Collection",
    "Camp & Drinkware Collection",
    "Packs & Transport Collection",
    "Replacement Parts Collection",
  ];
  document.querySelectorAll(".mega-menu__image-wrapper").forEach((el, i) => {
    if (megaLabels[i]) el.setAttribute("aria-label", megaLabels[i]);
  });

  const accessibilityLink = document.querySelector(".site-footer__linklist li a[href='/#']");
  if (accessibilityLink) accessibilityLink.setAttribute("data-awam-target", "true");
});
window.onload = function() {
  let formIframeGuarantee = document.querySelector("#bdbvy iframe");
  if(formIframeGuarantee) {
    formIframeGuarantee.setAttribute("title","Guarantee Form")
  };
  let formIframeReturns = document.querySelector("#fc456d iframe");
  if(formIframeReturns) {
    formIframeReturns.setAttribute("title","Returns Form")
  };
  let formIframeReachout = document.querySelector("#bnclm iframe");
  if(formIframeReachout) {
    formIframeReachout.setAttribute("title","Reach Out Form")
  };
};